export { default as DefaultBottom } from '@/assets/graphics/ribbons/default/bottom.svg';
export { default as DefaultTop } from '@/assets/graphics/ribbons/default/top.svg';
